import React from 'react';
import { Button, Modal, Container } from 'react-bootstrap';


class HARViewer extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.getHarOutput = this.getHarOutput.bind(this);
        this.isValueSet = this.isValueSet.bind(this);
        this.clearViewer = this.clearViewer.bind(this);
        this.hideHandler = this.hideHandler.bind(this);
        this.showHandler = this.showHandler.bind(this);

        this.state = {
            harOutput: null,
            logIdx: null,
            show: false
        };
    }
    clearViewer() {
        this.setState({
            harOutput: null
        });
    }
    getHarOutput(logId) { 
        if (logId) {
            var url = "/api/v1/extractions/" + this.props.extractionItem?.id + "/batches/" + this.props.batchID + "/jobs/" + encodeURIComponent(logId) + "/har"
            this.props.$.get(url, res => {
                this.setState({
                    harOutput: res,
                    logIdx: logId,
                    show: true
                });
            });
            return;
        }
        if (!this.props.isJobOutputAvailable()) {
            return;
        }
        var url = "/api/v1/extractions/" + this.props.jobDefinition.extraction_id + "/batches/" + this.props.batchID + "/jobs/" + encodeURIComponent(this.props.activeJobId) + "/har"
        this.props.$.get(url, res => {
            this.setState({
                harOutput: res
            });
        });
    }
    isValueSet() {
        return this.state.harOutput != null && (this.props.row_id == null || this.state.logIdx == this.props.row_id)
    }
    hideHandler() {
        this.setState({ show: false });
    }
    showHandler() {
        this.setState({ show: true });
    }
    render() {
        return (
            <div>
                <Button
                    variant="light"
                    onClick={() => this.getHarOutput(this.props.row_id)}
                >
                    Display HAR Output
                </Button>
                <div className="modal-container">
                    <Modal
                        show={this.state.show}
                        onHide={this.hideHandler}
                        centered
                        dialogClassName="asset-modal-wide"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title">
                                HAR Output
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>Copy the HAR output below and use <a href="http://www.softwareishard.com/har/viewer/" target="_blank" rel="noopener noreferrer">this service</a> to explain the details: </div>
                            {this.isValueSet() &&
                                this.state.harOutput
                            }
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.hideHandler}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        );
    }
}

export default HARViewer;